import ApolloClient from 'apollo-client';
import {setContext} from 'apollo-link-context';
import {onError} from 'apollo-link-error';
import {HttpLink} from 'apollo-link-http';
import {InMemoryCache} from 'apollo-cache-inmemory';

import config from './config';

const httpLink = new HttpLink({uri: config.apiUrl + '/graphql'});

const errorLink = onError(({networkError}) => {
  if (networkError && networkError.statusCode === 401) {
    config.removeAuthToken();
    window.location.reload();
  }
});

const authLink = setContext(() => ({headers: {authorization: config.getAuthHeader()}}));

const link = authLink.concat(errorLink).concat(httpLink);

export default new ApolloClient({link, cache: new InMemoryCache()});



// WEBPACK FOOTER //
// ./src/client.js